export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_01.c67448a2.jpg";